module.exports = __webpack_public_path__ + "static/media/CreditLimit.9690d61b.svg";